// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__O6rID","footer":"ModalFilter_footer__36z21"};